import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Upload, CheckCircle } from "lucide-react";
import { useToast } from "@/hooks/use-toast";

interface PdfUploadProps {
  onFileSelect: (file: File) => void;
  pdfFile: File | null;
}

export const PdfUpload = ({ onFileSelect, pdfFile }: PdfUploadProps) => {
  const { toast } = useToast();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file && file.type === "application/pdf") {
      onFileSelect(file);
      toast({
        title: "PDF Selected",
        description: "PDF file has been successfully uploaded",
        className: "bg-[#F2FCE2] border-green-200 text-green-800",
      });
    } else if (file) {
      toast({
        title: "Invalid file type",
        description: "Please upload a PDF file",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-2 items-center">
        <Button 
          variant="outline"
          onClick={() => document.getElementById('pdfUpload')?.click()}
          className="whitespace-nowrap"
        >
          {pdfFile ? (
            <>
              <CheckCircle className="mr-2 h-4 w-4 text-green-500" />
              PDF Selected
            </>
          ) : (
            <>
              <Upload className="mr-2 h-4 w-4" />
              Upload PDF
            </>
          )}
        </Button>
        <input
          id="pdfUpload"
          type="file"
          accept=".pdf"
          onChange={handleFileChange}
          className="hidden"
        />
      </div>
      {pdfFile && (
        <p className="text-sm text-muted-foreground mt-2">
          Selected file: {pdfFile.name}
        </p>
      )}
    </div>
  );
};